import script from "./HeaderComponent.vue?vue&type=script&lang=tsx&setup=true"
export * from "./HeaderComponent.vue?vue&type=script&lang=tsx&setup=true"

import "./HeaderComponent.vue?vue&type=style&index=0&id=281e557b&lang=scss&style=scoped"

const __exports__ = script;

export default __exports__